import { defineStore } from "pinia";
import { ref, computed, ComputedRef } from "vue";
import router from "@/router";
import routesName from "@/utils/constants/routesName";
import { UserRoleEnum } from "@/utils/enum/UserRoleEnum";

export const useUserStore = defineStore(
  "user",
  () => {
    interface IUser {
      id: number;
      email: string;
      phone: string;
      last_name: string;
      first_name: string;
      role: UserRoleEnum;
      created_at: string;
    }
    const accessToken = ref("");
    const refreshToken = ref("");
    const userRole = ref<UserRoleEnum | null>(null);
    const user = ref<IUser | null>(null);

    const setTokens = (payload: {
      access_token: string;
      refresh_token: string;
    }): void => {
      accessToken.value = payload.access_token;
      refreshToken.value = payload.refresh_token;
    };

    const isAdmin: ComputedRef<boolean> = computed(
      () => userRole.value === UserRoleEnum.admin
    );

    const isDistributionManager: ComputedRef<boolean> = computed(
      () => userRole.value === UserRoleEnum.distributionManager
    );
    const setRole = (role: UserRoleEnum): void => {
      userRole.value = role;
    };
    const setUserData = (userData: IUser): void => {
      user.value = userData;
    };

    const clear = (): void => {
      accessToken.value = "";
      refreshToken.value = "";
      userRole.value = null;
      user.value = null;
      router.push({ name: routesName.login });
    };

    return {
      accessToken,
      refreshToken,
      user,
      setTokens,
      setUserData,
      clear,
      isAdmin,
      isDistributionManager,
      setRole,
      userRole,
    };
  },
  {
    persist: {
      paths: ["accessToken", "refreshToken", "userRole", "user"],
    },
  }
);
